export const appColors = {
    interactiveBlue: '#086EA1',
    darkBlue: '#054C70',
    hoverBlue: '#043954',
    brightBlue: '#05C3DE',
    lightGray: '#EBEBEB ',
    gray: '#C4C4C4',
    mediumGray: '#898989',
    darkGray: '#3B3B3B',
    successGreen: '#7D9845',
    warningOrange: '#E17A17',
    errorRed: '#D82C26',
    appBarGradient: 'radial-gradient(farthest-corner at 20% -100%, #05C3DE -25%, #054C70 60%, #063046 105%)',
};

export default appColors;